import { CommonHelperFunctions, IRoleDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class RoleService {
  public static async Create(role: IRoleDto): Promise<AxiosResponse> {
    try {
      return await Axios.post<IRoleDto, AxiosResponse>(`${backendUrl}/roles/create`, role);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetAll(): Promise<AxiosResponse<IRoleDto[]>> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/roles/getall`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Get(id: string): Promise<AxiosResponse<IRoleDto>> {
    try {
      return await Axios.get<string, AxiosResponse>(`${backendUrl}/roles/${id}`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Update(id: string, obj: IRoleDto): Promise<AxiosResponse> {
    try {
      return await Axios.put<IRoleDto, AxiosResponse>(`${backendUrl}/roles/${id}`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Delete(id: string): Promise<boolean> {
    try {
      await Axios.delete<null>(`${backendUrl}/roles/${id}`);
      return true;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async AddAccessesToRole(obj: any): Promise<AxiosResponse> {
    try {
      return await Axios.post<any, AxiosResponse>(`${backendUrl}/roles/addaccessestorole`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetAccessRightsByRole(roleid: string): Promise<AxiosResponse> {
    try {
      return await Axios.get<string, AxiosResponse>(`${backendUrl}/roles/accessrights/${roleid}`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async AddUsersToRole(id: string, obj: any): Promise<AxiosResponse> {
    try {
      return await Axios.post<any, AxiosResponse>(`${backendUrl}/roles/adduserstorole/${id}`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async DeleteUserFromRole(id: string, obj: any): Promise<AxiosResponse> {
    try {
      return await Axios.post<any, AxiosResponse>(`${backendUrl}/roles/deleteuserfromrole/${id}`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async UpdateRoleActionAccesses(id: string, obj: any): Promise<AxiosResponse> {
    try {
      return await Axios.put<IRoleDto, AxiosResponse>(`${backendUrl}/roles/updateroleactionaccesses/${id}`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
